import qs from 'querystring'

import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import _ from 'underscore'
import STATUS_CODE from '../constant/status_code'

const url = COOKIECONSTANT.REQUEST_HOST
const emptyProductListData = {
  page: {
    pageNum: 0,
    total: 0,
  },
  list: [],
}

const getBillboards = () => new Promise((resolve, reject) => {
  Api.get(url, {
    headers: {
      'X-Host': 'mall.cfg.head-banners.v2',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getRecommend = () => new Promise((resolve, reject) => {
  Api.get(`${url}?type=19`, {
    headers: {
      'X-Host': 'mall.cfg.common-banner',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getBanner = () => new Promise((resolve, reject) => {
  Api.get(`${url}?type=20`, {
    headers: {
      'X-Host': 'mall.cfg.common-banner',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getShops = () => new Promise((resolve, reject) => {
  Api.get(url, {
    headers: {
      'X-Host': 'mall.cfg.topic.list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const getRecommendGoods = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  Api.get(`${url}${query}`, {
    headers: {
      'X-Host': 'mall.product.recommend-list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status === STATUS_CODE.EMPTY_LIST) {
      return resolve(emptyProductListData)
    }
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const queryQrcode = data => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(data), {
    headers: {
      'X-Host': 'mall.qrcode.query',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})
const getTopicGatherList = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const totalUrl = `${url}${query}`
    // let url = 'https://www.easy-mock.com/mock/5b6c13c04c01ef1691f86eb4/mall/api/topic/recommend-list'

  Api.get(totalUrl, {
    headers: {
      'X-Host': 'mall.cfg.topic.gather-list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})
const getHomeMenus = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const totalUrl = `${url}${query}`

  Api.get(totalUrl, {
    headers: {
      'X-Host': 'mall.category.recommend.v2',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
        .then((data) => {
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
})
/* yeoman-template-point-1 */
export default {
  getBillboards,
  getRecommend,
  getBanner,
  getShops,
  getRecommendGoods,
  queryQrcode,
  getTopicGatherList,
  getHomeMenus,
/* yeoman-template-point-2 */
}
